import axios from "axios";
import { SuperAdminURL } from "../../../../config/UrlEndPoint";

export const URL = `${SuperAdminURL}organization_classification`;

export function findOrganizationClassification(queryParams) {
  return axios.post(`${URL}/find`, queryParams);
}
export function createOrganizationClassification(payload) {
  return axios.post(`${URL}/create`, payload);
}
export function updateOrganizationClassification(payload) {
  return axios.put(`${URL}/update`, payload);
}
export function deleteOrganizationClassificationFolder(id) {
  return axios.delete(`${URL}/delete_folder/${id}`);
}

export function findorganizationClassificationFile(queryParams) {
  return axios.post(`${URL}/find_file`, queryParams);
}
export function createOrganizationClassificationFile(payload) {
  return axios.post(`${URL}/create_file`, payload);
}
export function deleteOrganizationClassificationFile(id) {
  return axios.delete(`${URL}/delete_file/${id}`);
}
